import { useEffect, useState, useCallback } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { getInstancesWithAdd, getInstancesWithAddglobal } from '../accounts/troubleshoot/request/request';
import Spinner from '../Spinner/Spinner';
import axios from 'axios';
import Swal from 'sweetalert2';
import { KTIcon } from '../../../../_metronic/helpers';
import { useAuth } from '../../auth';
import Modal1 from './components/modal1';
import Modal2 from './components/modal2';
import ModalSwal from '../../permisoDenegado/Modalswal';

const API_URL = process.env.REACT_APP_API_URL


type prefix = {
  seq: string,
  address: string,
  policy: string,
  ge: string,
  le: string
}
type vrf = {
  vendor: string,
  vrf: string
  subscription: (string)
}
type vecino = {
  ip: string,
  desc: string
}
type ID = undefined | null | number


export default function AddBGPSegment(props: any) {
  const { currentUser } = useAuth()
  const [ID, setID] = useState<ID>(undefined)


  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)



  const [Instancia, setInstancia] = useState([{
    id: 0,
    name: " ",
    type: ''

  }])

  const [Busqueda, setBusqueda] = useState("")

  const [Datos, setDatos] = useState<prefix[]>([])
  const [listvrf, setlistvrff] = useState<vrf[]>([])



  ////////////////////////////////////////////////////////////
  const [vrfselect, setselectvrf] = useState<any>()
  const [action, setaction] = useState<any>()
  const [prefix, setprefix] = useState<any>()
  const [greater, setgreater] = useState<number>(0)
  const [less, setless] = useState<number>(0)
  const [vecino, setvecino] = useState<any>()


  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }

  const vrfseleccionada = (e: any) => {
    setselectvrf(e.target.value)
  }

  const actionselect = (e: any) => {
    setaction(e.target.value)
  }

  const vecinoseleccionado = (e: any) => {
    setvecino(e.target.value)
  }

  /**********************Llamada a axios y parse de data**********************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {

          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.BGP.List', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.BGP.List', Type, nameregion);
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
        }
        else if (Id !== 0 && Id !== -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {

          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, nameregion]
  )





  /////////////////////////////


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Busqueda !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }
          if (type === "ctx") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/listVrf', body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
          }
          else if (type === "add") {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: Id
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
            if (tenant === 0) {
              await axios.post(API_URL + '/v1/listVrf/add', body)
                .then(res => {
                  setlistvrff(res.data)
                })
            }
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Busqueda, Id])

  const [listvecino, setlistvecino] = useState<vecino[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Busqueda !== '' && vrfselect !== undefined && vrfselect !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[vrfselect]

          if (type === "ctx") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor', body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
          }
          else if (type === "add") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            if (tenant !== 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
            else if (tenant === 0) {
              await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor', body)
                .then(res => {
                  setlistvecino(res.data)
                })
            }
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [vrfselect])
  /**********************************Se obtienen datos para la prefixlist******************************************/
  const [loading, setLoading] = useState(false)


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (Id !== 0 && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {
      try {
        if (Busqueda === '') {
          Swal.fire(
            'Oooops!',
            'Please select an Instance',
            'warning',
          )
        }
        else if (vrfselect === '') {
          Swal.fire(
            'Oooops!',
            'Please select a VRF',
            'warning',

          )
        }
        else if (vecino === '') {
          Swal.fire(
            'Oooops!',
            'Please select a Neighbor',
            'warning',

          )
        }
        else if (Busqueda !== '' && vrfselect !== '' && vecino !== '') {
          setLoading(true)
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          const vrf = listvrf[vrfselect]
          const body = {
            type: type,
            vrf: vrf,
            neighbor: vecino
          }


          if (tenant !== 0) {
            await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_prefix?tenantId=' + tenant, body)
              .then(res => {
                setDatos(res.data)
              })
          }

          if (tenant === 0) {
            await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_prefix', body)
              .then(res => {
                setDatos(res.data)
              })
          }
        }
      }
      catch (error: any) {
        console.log(error)

      }
      finally {
        setLoading(false);
      }

    }
  }
  /*********************************************SE REALIZA POST PARA AGREGAR PREFIX LIST*********************** */
  const [add, setadd] = useState(false)
  const vrff = listvrf[vrfselect]

  let typead
  for (const x of Instancia) {
    if (Number(Busqueda) === x.id) {
      typead = x.type
    }
  }

  const ADDSegment = async (e: any) => {
    e.preventDefault();
    if (Id !== 0 && Busqueda !== '' && vecino !== '' && prefix !== '' && currentUser?.ListPermiso?.includes('Ctx.BGP.Add')) {
      try {
        setadd(true)
        let type
        for (const x of Instancia) {
          if (Number(Busqueda) === x.id) {
            type = x.type
          }
        }

        const vrf = listvrf[vrfselect]
        const body = {
          type: type,
          vrf: vrf,
          neighbor: vecino,
          prefix: {
            ip: prefix,
            ge: greater,
            le: less,
            policy: action
          }
        }
        // Muestra el SweetAlert antes de realizar la primera solicitud
        /*Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Tu Segmento está siendo agregado, este proceso puede tardar unos segundos, por favor espera',
          showConfirmButton: false,
          allowOutsideClick: false // Evitar que el usuario cierre el alert haciendo clic fuera de él
        });*/

        // Realiza la primera solicitud axios
        if (tenant === 0) {
          const response = await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/add_prefix', body);
          setDatos(response.data);
        }
        else {
          const response = await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/add_prefix?tenantId=' + tenant, body);
          setDatos(response.data);
        }


      }
      catch (error: any) {
        console.log(error)

      }
      finally {
        setadd(false);
      }

    }
  }

  /*********************************************SE REALIZA DELETE para prefix list ********************** */
  const [del, setdel] = useState(false)

  function deleteprefix(id: any, prefixx: any, lessthan: any, greaterthan: any, policy: any) {
    if (Id !== 0 && Busqueda !== '' && vecino !== '' && prefix !== '' && currentUser?.ListPermiso?.includes('Ctx.BGP.Delete')) {
      try {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this BGP Segment!",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
          .then((result) => {

            if (result.isConfirmed) {
              setdel(true)
              const elemento = document.getElementById("delete" + id)

              if (elemento != null) {
                elemento.innerText = 'Deleting...'
              }

              let type
              for (const x of Instancia) {
                if (Number(Busqueda) === x.id) {
                  type = x.type
                }
              }

              const vrf = listvrf[vrfselect]
              const body = {
                type: type,
                vrf: vrf,
                neighbor: vecino,
                seq: id,
                prefix: prefixx,
                lessthan: lessthan,
                greaterthan: greaterthan,
                policy: policy
              }
              axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/del_prefix?tenantId=' + tenant, body).then(res => {
                setDatos(res.data)
                Swal.fire(
                  'Deleted!',
                  'Your BGP Segment has been deleted.',
                  'success'
                );
                if (elemento != null) {
                  elemento.innerText = 'Delete'
                }
                setdel(false)
              })
            } else {
              Swal.fire({ title: "Your BGP Segment is safe!", icon: "success" });
            }
          });
      }
      catch (error: any) {
        console.log(error)

      }

    }
  }


  ///////////////////////////////////////////////////GLOBAL////////////////////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(-1, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }
          }
          else {
            const instancias = await getInstancesWithAddglobal(-1, tenant, 'Ctx.BGP.List');
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0].id)
            }

          }

        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id]
  )

  /////////////////////////////

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Type === 'CloudGlobal' && Busqueda !== '') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          if (type === 'ctx') {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: '-1'
            }
            await axios.post(API_URL + '/v1/listVrf?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }
          if (type === 'add') {
            const body =
            {
              instanceId: Number(Busqueda),
              suscriptionId: '-1'
            }
            await axios.post(API_URL + '/v1/listVrf/add?tenantId=' + tenant, body)
              .then(res => {
                setlistvrff(res.data)
              })
          }


        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Busqueda, Id, Type])
  ////////////////////////////
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Busqueda !== '' && vrfselect !== undefined && vrfselect !== '' && Type === 'CloudGlobal') {
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }
          const vrf = listvrf[vrfselect]

          if (type === "ctx") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
              .then(res => {
                setlistvecino(res.data)
              })
          }
          else if (type === "add") {
            const body =
            {
              type: type,
              vrf: vrf
            }
            await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_neighbor?tenantId=' + tenant, body)
              .then(res => {
                setlistvecino(res.data)
              })
          }
        }
      }
      catch {
        console.log('nose puede')
      }
    };
    fetchData();
  }, [Id, vrfselect])

  /**********************************Se obtienen datos para la prefixlist******************************************/
  const handleSubmitGlobal = async (e: any) => {
    //e.preventDefault();
    if (Id === -1 && Type == 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.List')) {
      try {

        if (Busqueda === '') {
          Swal.fire(
            'Oooops!',
            'Please select an Instance',
            'warning',
          )
        }
        else if (vrfselect === '') {
          Swal.fire(
            'Oooops!',
            'Please select a VRF',
            'warning',

          )
        }
        else if (vecino === '') {
          Swal.fire(
            'Oooops!',
            'Please select a Neighbor',
            'warning',

          )
        }
        else if (Busqueda !== '' && vrfselect !== '' && vecino !== '') {
          setLoading(true)
          let type
          for (const x of Instancia) {
            if (Number(Busqueda) === x.id) {
              type = x.type
            }
          }

          const vrf = listvrf[vrfselect]
          const body = {
            type: type,
            vrf: vrf,
            neighbor: vecino
          }


          await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_prefix?tenantId=' + tenant, body)
            .then(res => {
              setDatos(res.data)
            })

        }

      }
      catch (error: any) {
        console.log(error)

      }
      finally {
        setLoading(false);
      }

    }
  }

  /*********************************************SE REALIZA POST PARA AGREGAR PREFIX LIST*********************** */
  const ADDSegmentGlobal = async (e: any) => {
    e.preventDefault();
    if (Id === -1 && Busqueda !== '' && vecino !== '' && prefix != '' && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.Add')) {
      try {
        setadd(true)
        let type
        for (const x of Instancia) {
          if (Number(Busqueda) === x.id) {
            type = x.type
          }
        }

        const vrf = listvrf[vrfselect]
        const body = {
          type: type,
          vrf: vrf,
          neighbor: vecino,
          prefix: {
            ip: prefix,
            ge: greater,
            le: less,
            policy: action
          }
        }


        // Realiza la primera solicitud axios
        await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/add_prefix?tenantId=' + tenant, body);

        // Realiza la segunda solicitud axios
        const response = await axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_prefix?tenantId=' + tenant, body);
        setDatos(response.data);

      }
      catch (error: any) {
        console.log(error)

      }
      finally {
        setadd(false);
      }

    }
  }

  /*********************************************SE REALIZA DELETE para prefix list ********************** */
  function deleteprefixGlobal(id: any, prefixx: any, lessthan: any, greaterthan: any, policy: any) {
    if (Id === -1 && Busqueda !== '' && vecino !== '' && prefix != '' && Type == 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.BGP.Delete')) {
      try {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this BGP Segment!",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        })
          .then((result) => {

            if (result.isConfirmed) {
              setdel(true)
              let type
              for (const x of Instancia) {
                if (Number(Busqueda) === x.id) {
                  type = x.type
                }
              }

              const vrf = listvrf[vrfselect]
              const body = {
                type: type,
                vrf: vrf,
                neighbor: vecino,
                seq: id,
                prefix: prefixx,
                lessthan: lessthan,
                greaterthan: greaterthan,
                policy: policy
              }
              axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/del_prefix?tenantId=' + tenant, body).then(res => {
                Swal.fire(
                  'Deleted!',
                  'Your BGP Segment has been deleted.',
                  'success'
                );

                axios.post(API_URL + '/v1/BGP/instances/' + Busqueda + '/list_prefix?tenantId=' + tenant, body)
                  .then(res => {
                    setDatos(res.data)
                    setdel(false)
                  })

              })
            } else {
              Swal.fire({ title: "Your BGP Segment is safe!", icon: "success" });
            }
          });
      }
      catch (error: any) {
        console.log(error)

      }
      finally {
        setdel(false);
      }


    }
  }




  useEffect(() => {
    if (Busqueda) {
      setDatos([])
    }
  }, [Busqueda, vrfselect])

  useEffect(() => {
    if (Busqueda) {
      setselectvrf('')
      setlistvecino([])
      setvecino('')
      setgreater(0)
      setless(0)
      setaction('')
    }
  }, [Busqueda])

  useEffect(() => {
    if (vrfselect) {
      setvecino('')
      setgreater(0)
      setless(0)
      setaction('')
    }
  }, [vrfselect])
  /******************************check box **************/
  /////////////////////////
  const [isChecked, setIsChecked] = useState(false);


  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };

  /*********************************Modales */
  const [modal1Visible, setModal1Visible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);
  const handleModal1Click = () => {
    setModal1Visible(true);
  };

  const handleModal2Click = () => {
    setModal2Visible(true);
  };

  const handleCloseModal1 = () => {
    setModal1Visible(false);
  };

  const handleCloseModal2 = () => {
    setModal2Visible(false);
  }

  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions)
  const MostrarModal = !(ListaPermisosTenant.includes('Ctx.BGP.Add') || ListaPermisosTenant.includes('Ctx.BGP.List') || ListaPermisosTenant.includes('Ctx.BGP.Delete'))
  return (
    <>
      {loading && <Spinner></Spinner>}
      {add && <Spinner></Spinner>}
      {del && <Spinner></Spinner>}
      <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>View and add BGP segments</span>
          </h3>
          {/*Se agrega Boton para agregar usuarios*/}
          {/*<Link style={{marginRight:'15px'}}to="/create" className='btn btn-primary'>Add Nex User</Link>*/}
          {        /*   <button onClick={ () => setID(null)}  disabled={vecino===''}className='btn btn-primary'> Add Bulk of BGP Segments</button>
*/}        </div>

        {/* end::Header */}
        <br />
        <div className="d-flex flex-center">
          <div className='fv-row '>
            <div className='row '>

              <div className='col-lg-3'>
                <label className='form-label f-bold fs-p text-marino required form-label' >Instance</label>
                <select className="form-select border-marino f-parrafo fs-p text-dk text-center w-200px" aria-label="Select example"
                  onChange={cambiarstate} value={Busqueda}>
                  {Instancia.length === 0 && <option disabled selected hidden>No data</option>}
                  <option disabled selected hidden defaultValue={0}>Select an Instance </option>
                  {Id !== 0 && Id !== -1 && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                  {Id === -1 && Type === 'CloudGlobal' && Instancia.map((ins: any, x: any) =>
                    <option key={x} value={ins.id}>{ins.name}</option>
                  )
                  }
                </select>
              </div>
              <div className='w-30px'></div>

              <div className='col-lg-3'>
                <label className='form-label f-bold fs-p text-marino required form-label' >VRF</label>
                <select className="form-select border-marino f-parrafo fs-p text-dk text-center w-200px" aria-label="Select example"
                  onChange={vrfseleccionada} value={vrfselect}>
                  {listvrf?.length === 0 ? <option key={'x'} className='text-danger bg-info' hidden>No VRF</option> : <option hidden>Select an VRF </option>}

                  {Busqueda !== '' && Id !== 0 && Id != -1 && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                    <>
                      {!vrf.vrf && <option key={i} value={i}>Main</option>}
                      {vrf.vrf && <option key={i} value={i}>{vrf.vrf}</option>}
                    </>
                  )
                  }

                  {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf: any, i) =>
                    <>
                      {!vrf.vrf && <option key={i} value={i}>Main({vrf.subscriptions})</option>}
                      {vrf.vrf && <option key={i} value={i}>{vrf.vrf}({vrf.subscriptions})</option>}
                    </>
                  )
                  }
                </select>

              </div>
              <div className='w-30px'></div>

              <div className='col-lg-3'>
                <label className='form-label f-bold fs-p text-marino required form-label' >Neighbor</label>
                <select className="form-select border-marino f-parrafo fs-p text-dk text-center w-200px" aria-label="Select example"
                  onChange={vecinoseleccionado} value={vecino}>

                  {listvecino?.length === 0 ? <option key={'c'} className='text-danger bg-info' hidden>No Neighbor</option> : <option hidden>Select an Neighbor </option>}

                  {Busqueda !== '' && Id !== 0 && Id !== -1 && listvecino.length !== 0 && listvecino.length !== undefined && listvecino.length !== null && listvecino?.map((nei: any, i: any) =>
                    <>
                      {nei.desc !== 'N/A' ? <option key={i} value={nei.ip}>{nei.ip} {nei.desc}</option> : <option key={i} value={nei.ip}>{nei.ip}</option>}
                    </>
                  )
                  }

                  {Busqueda !== '' && Id === -1 && Type === 'CloudGlobal' && listvecino.length !== 0 && listvecino.length !== undefined && listvecino.length !== null && listvecino?.map((nei: any, i) =>
                    <>
                      {nei.desc !== 'N/A' ? <option key={i} value={nei.ip}>{nei.ip} {nei.desc}</option> : <option key={i} value={nei.ip}>{nei.ip}</option>}

                    </>
                  )
                  }
                </select>
              </div>
              <div className='w-30px'></div>

              <div className='col-lg-1' style={{ marginTop: '13px' }}>
                <br />
                {currentUser?.ListPermiso?.includes('Ctx.BGP.List') && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && <button type='submit' onClick={handleSubmit} className="btn-light-marino f-parrafo">{loading ? 'Searching...' : 'Search'}</button>}
                {currentUser?.ListPermiso?.includes('Ctx.BGP.List') && Type === 'CloudGlobal' && <button type='submit' onClick={handleSubmitGlobal} className="btn-light-marino f-parrafo">{loading ? 'Searching...' : 'Search'}</button>}

              </div>


            </div>
          </div>
        </div>
        <br />
        <br />

        <div className="d-flex flex-wrap fw-bold  mb-4 pe-2 flex-center f-titulo fs-sub" > Add BGP Segments</div>
        <div className='row g-5 g-xl-8'>
          <div className='col-xl-6' >
            <div className='rounded-lg border bg-card shadow-sm  border-gray-300 card h-100' style={{ marginRight: '5px', marginLeft: '20px' }} >
              <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                <div className='f-bold fs-4 mb-2 text-marino'>Add Single BGP Segment</div>
                <div className='f-parrafo fs-p text-marino mt-auto'>Use this option to add a single BGP segment to your configuration.</div><br />
                <div className='symbol symbol-75px mb-6'>
                  <svg viewBox="0 0 21 21" width="30"
                    height="30"
                    xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="translate(3 2)">
                      <path d="m6.5 3.5h-4c-1.1045695 0-2 .8954305-2 2v7c0 1.1045695.8954305 2 2 2h7c1.1045695 0 2-.8954305 2-2v-3.5-.5" /><path d="m11.5.5v6" /><path d="m11.5.5v6" transform="matrix(0 1 -1 0 15 -8)" />
                    </g>
                  </svg>
                </div>
                <div className='text-center mx-auto'>
                  <button className='btn-gradiente' style={{ padding: '6px', width: '200px' }} onClick={handleModal1Click}>Add BGP Segment</button>
                </div>
                <Modal1 showModal={modal1Visible} handleClose={handleCloseModal1} setDatos={setDatos} />

              </div>
            </div>
          </div>
          <div className='col-xl-6'>
            <div className='rounded-lg border bg-card shadow-sm  border-gray-300 card h-100' style={{ marginLeft: '5px', marginRight: '20px' }} >
              <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                <div className='f-bold fs-4 mb-2 text-marino'>Add Multiple BGP Segments</div>
                <div className='f-parrafo fs-p text-marino mt-auto'>Use this option to add multiple BGP segments at once to your configuration.</div><br />
                <div className='symbol symbol-75px mb-6'>
                  <svg height="25" viewBox="0 0 21 21" width="25" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" transform="translate(4 2)"><path d="m.5 3.20588235c0-1.29949353 2.5-2.74110534 6-2.70588235s6 1.55344765 6 2.85294118v10.29411762c0 1.2994936-2.5 2.8529412-6 2.8529412s-6-1.7005065-6-3c0-.6412832 0-9.65283449 0-10.29411765z" /><path d="m.5 3.5c0 1.38071187 2 3 6 3s6-1.63689962 6-3.0176115m-12 5.0176115c0 1.38071187 2 3 6 3s6-1.63689962 6-3.0176115" /></g></svg>
                </div>
                <div className='text-center mx-auto'>
                  <button className='btn-gradiente' style={{ width: '200px', padding: '6px' }} onClick={handleModal2Click}>Add Bulk</button>
                </div>
                <Modal2 showModal={modal2Visible} handleClose={handleCloseModal2} setDatos={setDatos} />
              </div>
            </div>
          </div>
        </div>

        <br />
        {Datos.length !== 0 && <div className="d-flex flex-center">
          <div className='fv-row '>
            <div className='row '>

              <div className="text-center">
                <div className="separator separator-dashed border-info opacity-25 "></div>
                <div className='f-parrafo fs-p'>
                  Total BGP Segments: {Datos.length}
                </div>
                <div className="separator separator-dashed border-info opacity-25 "></div>
              </div>

            </div>
          </div>
        </div>}
        <br />



        {/* begin::Body */}
        <div className='card-body py-0'>
          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}
              <div className='table-responsive'>

                {/* begin::Table */}
                <table className="w-full f-parrafo  caption-bottom  custom-table" id='table'>
                  {/* begin::Table head */}
                  <thead className="table-header-light bg-marino">
                    <tr >
                      <th className='table-cell'>Seq</th>
                      <th className='table-cell'>Prefix</th>
                      <th className='table-cell'>Less Than</th>
                      <th className='table-cell'>Greater Than</th>
                      <th className='table-cell'>Policy</th>
                      <th className='table-cell'>Delete</th>

                    </tr>
                  </thead>
                  {/* end::Table head */}


                  {/* begin::Table body */}
                  <tbody>
                    {Datos.length === 0 ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                          No Data Available
                        </td>
                      </tr>
                    ) : (
                      Datos.map((d, i) => (
                        <tr key={i} className='table-row'>
                          <td className='table-cell'> {d.seq}  </td>
                          <td className='table-cell'> {d.address}  </td>
                          {d.le === '' ? <td className='table-cell'>---</td> : <td className='table-cell'>{d.le}</td>}
                          {d.ge === '' ? <td className='table-cell'>---</td> : <td className='table-cell'>{d.ge}</td>}
                          {d.policy === "permit" && (
                            <td id='id' className='table-cell'>
                              {d.policy} <br />
                              <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />
                            </td>
                          )}
                          {d.policy === "deny" && (
                            <td id='id' className='table-cell'>
                              <KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' /> {d.policy}
                            </td>
                          )}
                          <td className='table-cell'>
                            {currentUser?.ListPermiso?.includes('Ctx.BGP.Delete') && Id !== 0 && Id !== -1 && Type !== 'CloudGlobal' && (
                              <button className='btn-light-marino f-parrafo' id={'delete' + d.seq} onClick={() => deleteprefix(d.seq, d.address, d.le, d.ge, d.policy)}>
                                Delete
                              </button>
                            )}
                            {currentUser?.ListPermiso?.includes('Ctx.BGP.Delete') && Type === 'CloudGlobal' && (
                              <button className='btn-light-marino f-parrafo' id={'delete' + d.seq} onClick={() => deleteprefixGlobal(d.seq, d.address, d.le, d.ge, d.policy)}>
                                Delete
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                  {/* end::Table body */}

                </table>
                {/* end::Table */}
              </div>
              <br />
              <br />
            </div>
            {/* end::Tap pane */}
          </div>
        </div>
        <br />
        {/* end::Body */}
      </div>

    </>

  )

}
